import { useContext, useMemo, useRef } from "react";
import UsePagination from "../core/components/usePagination";
import { FaUserCircle } from "react-icons/fa";
import UserContext from "../core/UserContext";
import GoBack from "../core/components/goBack";
import { useAccounts } from "../core/lib/mockAccounts";
import apiRoutes from "../api/apiRoutes";
import { useParams } from "react-router-dom";
import Navbar from "../core/components/NavBar";

export default function TransactionHistory() {
  const { userData, setUserData } = useContext(UserContext);
  const ref = useRef();
  const params = useParams();

  console.log("params:", params);

  const {
    currentItems,
    itemsPerPage,
    currentPage,
    onLimitChange,
    onPageChange,
  } = useAccounts({
    endpoint: apiRoutes.allAccounts,
    worker: userData.data.id,
  });

  const { allPpaSummary } = useAccounts({
    endpoint: apiRoutes.allPpaSummary,
    param: params.id,
  });

  const selectedProfile = allPpaSummary?.[0] || {};

  const { selectedPolicy, filteredQuotations } = useMemo(() => {
    // 1. First try to find in currentItems
    const policy = currentItems.find((item) => item.id === Number(params.id));

    // 2. If not found, look in allPpaSummary
    const ppaPolicy = allPpaSummary?.find(
      (ppa) =>
        String(ppa.userId) === params.id ||
        String(ppa.userJointId) === params.id
    );

    const finalPolicy = policy || ppaPolicy;

    if (!finalPolicy) {
      console.log("No policy found", {
        currentItems,
        allPpaSummary,
        paramsId: params.id,
      });
      return { selectedPolicy: null, filteredQuotations: [] };
    }

    // 3. If policy comes from allPpaSummary, format it to match expected structure
    const formattedPolicy =
      finalPolicy === ppaPolicy
        ? {
            ...finalPolicy,
            name: finalPolicy.user?.name || "N/A",
            temporaryId: finalPolicy.temporaryId || "N/A",
            quotations: [],
            jointQuotations: [],
          }
        : finalPolicy;

    // 4. Create transaction data from allPpaSummary if that's our source
    const transactions =
      finalPolicy === ppaPolicy
        ? allPpaSummary
            .filter(
              (ppa) =>
                String(ppa.userId) === params.id ||
                String(ppa.userJointId) === params.id
            )
            .map((ppa) => ({
              id: ppa.id,
              intendedCommencementDate: ppa.intendedCommencementDate,
              premiumAmount: ppa.premiumAmount,
              initialSumAssured: ppa.initialSumAssured,
              fundValue: ppa.fundValue,
              paymentInsurancePlan:
                ppa.paymentFrequency || ppa.paymentInsurancePlan,
            }))
        : [
            ...(finalPolicy.quotations || []),
            ...(finalPolicy.jointQuotations || []),
          ].filter(Boolean);

    return {
      selectedPolicy: formattedPolicy,
      filteredQuotations: transactions,
    };
  }, [currentItems, params.id, allPpaSummary]);

  const paginatedQuotations = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredQuotations.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredQuotations, currentPage, itemsPerPage]);

  console.log("pq", paginatedQuotations);
  console.log("crt", currentItems);
  console.log("spro", selectedProfile);
  console.log("spol", selectedPolicy);
  console.log("allppa", allPpaSummary);

  return (
    <>
      <Navbar
        name={
          userData
            ? `${userData?.data?.firstname} ${userData?.data?.lastname}`
            : ""
        }
      />

      <div className="">
        <GoBack />
      </div>

      <section className="tw-font-haas container tw-px-3 sm:tw-px-5 tw-w-full tw-max-w-7xl tw-mx-auto">
        <section className="tw-py-6">
          <div className="tw-space-y-6">
            <div className="tw-flex tw-items-center tw-gap-x-2">
              <FaUserCircle className="tw-w-10 tw-h-10 tw-flex-shrink-0" />
              <div>
                <span className="tw-font-semibold tw-text-lg">
                  {selectedPolicy?.name || selectedProfile?.name || "N/A"}
                </span>
                <p className="tw-text-black/50 tw-m-0">
                  {selectedPolicy?.temporaryId ||
                    selectedProfile?.temporaryId ||
                    "N/A"}
                </p>
              </div>
            </div>
            <div>
              <h4 className="tw-font-semibold tw-text-xl tw-mb-0">
                Transaction History
              </h4>
              <p className="tw-text-gray-600">
                Keep track of all your premium payments in one place. View
                detailed breakdowns of your contributions, including amounts
                allocated to risk and investment, payment frequency, and
                statements.
              </p>
            </div>
          </div>
        </section>

        <div className="tw-w-full tw-overflow-x-auto">
        <table
          ref={ref}
          className="table tw-table-auto tw-whitespace-nowrap tw-min-w-full tw-mt-0"
        >
          <thead className="tw-w-full tw-h-[40px]">
            <tr className="tw-border-t tw-border-b tw-border-black/10 tw-bg-[#F1F4D0]">
              <th className="!tw-text-[#BEC663]">Date</th>
              <th className="!tw-text-[#BEC663]">First Premium(MUR)</th>
              <th className="!tw-text-[#BEC663]">Risk Allocation(MUR)</th>
              <th className="!tw-text-[#BEC663]">
                Investment Allocation (MUR)
              </th>
              <th className="!tw-text-[#BEC663]">Payment Frequency</th>
            </tr>
          </thead>

          <tbody className="tw-text-sm tw-capitalize">
            {paginatedQuotations.map((quotation, index) => (
              <tr key={`${quotation.id}-${index}`} className="tw-h-[50px]">
                <td>
                  {quotation.intendedCommencementDate
                    ? new Date(
                        quotation.intendedCommencementDate
                      ).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })
                    : "Not Available"}
                </td>
                <td className="tw-font-mono">
                  {quotation?.premiumAmount
                    ? parseFloat(quotation.premiumAmount).toLocaleString()
                    : 0}
                </td>
                <td className="tw-font-mono">
                  {quotation?.initialSumAssured
                    ? parseFloat(quotation.initialSumAssured).toLocaleString()
                    : 0}
                </td>
                <td className="tw-font-mono">
                  {quotation?.fundValue
                    ? parseFloat(quotation.fundValue).toLocaleString()
                    : 0}
                </td>
                <td>{quotation?.paymentInsurancePlan || "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>

        {filteredQuotations.length > 0 && (
          <UsePagination
            pgdrop="tw-hidden"
            limit={itemsPerPage}
            total={filteredQuotations.length}
            currentPage={currentPage}
            totalPages={Math.ceil(filteredQuotations.length / itemsPerPage)}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
          />
        )}
      </section>
    </>
  );
}
